export default {
  meta: {
    title: '隐私政策-路过',
    urlName: '隐私政策-路过' // 埋点字段，上报归属的模块
  }
};
